import React, { Component } from "react";
import { CSSTransition } from "react-transition-group";
import get from "lodash/get";
import "./form_dropdown.scss";
import upChevron from "../../../icons/up-chevron.svg";
import downChevron from "../../../icons/down-chevron.svg";

class FormDropdown extends Component {
  state = {
    show: false,
    showChildren: false,
  };

  toggleState = () => {
    this.setState({ show: !this.state.show, initialHide: false });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (get(nextProps, "validationErrors", []).length) {
      this.setState({ show: true });
    }
  }

  getButton = () => {
    const closedStateChevron = this.props.closedStateChevron || upChevron;
    const iconSrc = this.state.show ? closedStateChevron : downChevron;
    return (
      <div className="form-dropdown-wrapper margin-bottom--medium" onClick={this.toggleState}>
        <span>{this.props.label || "More Options"}</span>
        <span onClick={this.toggleState} className="form-dropdown-wrapper__chevron">
          <img src={iconSrc} alt={"dropdown-icon"} />
        </span>
      </div>
    );
  };
  render() {
    return (
      <div>
        {this.getButton()}
        <CSSTransition
          classNames={"form-dropdown"}
          in={this.state.show}
          timeout={300}
          onEnter={() => {
            this.setState({ showChildren: true });
          }}
          onExited={() => {
            this.setState({ showChildren: false });
          }}>
          <div style={{ display: this.state.showChildren ? "block" : "none" }}>
            {this.props.children}
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default FormDropdown;
